import { MaintenanceFiltersSchema } from 'core/schemas/maintenanceFilters';
import { Maintenance } from 'core/types/maintenance';

import usePaginationHandler from './usePaginationHandler';

export default function useMaintenances(params: MaintenanceFiltersSchema) {
  return usePaginationHandler<Maintenance>('maintenances', params);
}
